import { Component } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { filter, map, startWith, take } from "rxjs/operators";
import { LocationStateQuery } from "../../configuration/state/location-state.query";
import { SettingsComponent } from "../settings/settings.component";
import { StatisticsComponent } from "../statistics/statistics.component";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Component({
	selector: "app-menu-bar",
	templateUrl: "./menu-bar.component.html",
	styleUrls: ["./menu-bar.component.scss"],
})
export class MenuBarComponent {
	constructor(
		private router: Router,
		private modalController: ModalController,
		private locationStateQuery: LocationStateQuery,
		public rideOpsUi: RideOpsUiService,
	) {}

	currentUrl$ = this.router.events.pipe(
		filter((event): event is NavigationEnd => event instanceof NavigationEnd),
		map((event) => event.urlAfterRedirects),
		startWith(this.router.url),
		map((url) => {
			const path = url.split(/[?#]/)[0] || "/";
			return path === "/" ? "/dashboard" : path;
		}),
	);

	showNotesIcon$ = this.locationStateQuery.noteTypes$.pipe(
		map((noteTypes) => noteTypes.filter((type) => type.isDeleted === false)),
		map((noteTypes) => noteTypes.length > 0),
	);

	pendingHandoverAcknowledgements$ = this.locationStateQuery.isClearedForOperationDetails$.pipe(
		map((details) => details.noteHandoversRequiringAcknowledgement?.length ?? 0),
	);

	allowNavigation$ = this.locationStateQuery.operatorIsSelected$;
	allowStatisticsForOperator$ = this.locationStateQuery.allowStatisticsForOperator$;

	settings = async () => {
		const allowNavigation = await this.allowNavigation$.pipe(take(1)).toPromise();
		if (allowNavigation !== true) {
			return;
		}

		const settingsModal = await this.modalController.create({
			component: SettingsComponent,
		});

		await settingsModal.present();
	};

	statistics = async () => {
		const allowNavigation = await this.allowNavigation$.pipe(take(1)).toPromise();
		if (allowNavigation !== true) {
			return;
		}

		if (this.rideOpsUi.isV2Active()) {
			await this.router.navigate(["/statistics"]);
			return;
		}

		const statisticsModal = await this.modalController.create({
			component: StatisticsComponent,
			cssClass: "statistics-modal auto-height",
		});

		await statisticsModal.present();
	};
}
